import React, { Component } from 'react';
import { Grid, Rating, Divider } from 'semantic-ui-react';

export default class Languages extends Component {
    render () {
        return (
            <Grid.Column widescreen={8} largeScreen={8} computer={8} tablet={16} mobile={16}>
                <h3>Languages</h3>
                <Divider horizontal />
                <Divider horizontal />
                
                <div>
                    <h4 style={{display: 'inline'}}>Spanish</h4>, native
                    <Divider horizontal fitted/>
                    <Rating defaultRating={6} size={"huge"} maxRating={6} disabled/>
                </div>

                <Divider horizontal />
                <Divider horizontal />

                <div>
                    <h4 style={{display: 'inline'}}>English</h4>, upper intermediate
                    <Divider horizontal fitted/>
                    <Rating defaultRating={4} size={"huge"} maxRating={6} disabled/>
                </div>
            </Grid.Column>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Languages.js